export default "__VITE_ASSET__YuL6xc13__"